import {Controller} from "@hotwired/stimulus"
import { skeletonMessage } from "../helpers/dom_helpers"

const csrfToken = document.getElementsByName("csrf-token")[0].content;

export default class MessageController extends Controller {
    static values = { senderId: Number }

    connect() {
        const messageChatBox = this.element.parentElement.classList.contains('chat-text-content')
        if (messageChatBox) {
            const currentUser = document.getElementById('message').dataset.currentUserId
            if (Number.parseInt(currentUser) === this.senderIdValue) {
                this.element.closest('.message-box-holder')?.classList.remove('align-items-start')
                this.element.closest('.message-box-holder')?.classList.add('align-items-end')
                $(this.element)?.parent()?.parent()?.children()[0]?.classList.remove('left-shape-box')
            } else {
                this.element.closest('.message-box-holder')?.classList.add('align-items-start')
                this.element.closest('.message-box-holder')?.classList.remove('align-items-end')
                $(this.element)?.parent()?.parent()?.children()[0]?.classList.add('left-shape-box')
            }
        }
    }

    updateMessageSetting(e) {
        $(e.target).closest('form')[0].requestSubmit()
    }

    selectConversation(e) {
        if (!$(e.target)?.closest('.room-user')[0]?.classList?.contains('active')) {
            // update the window location URL when open the chat from search action
            const roomId = new URL(e.currentTarget.href).searchParams.get("room_id")
            if (roomId) {
                window.history.replaceState({}, "", `/messages/${roomId}`)
            }
            let field = $('.room-user').not($(e.target).closest('.room-user'))
            $(e.target).closest('.room-user').addClass('active')
            $(e.target).closest('.room-user').addClass('disabled-link')
            field.removeClass('active')
            field.removeClass('disabled-link')
            $("#chat-area").html(skeletonMessage());
            if (window.innerWidth < 512) {
                $('#user-list').addClass('d-none');
                $("#chat-area").removeClass('d-none');
            }
        }
    }

    forwardMsg(e){
        let value = $(e.target).val()
        let hiddenInput = $('input[type=hidden][id=message_value]');
        hiddenInput.attr('value', value)
    }

    reportConversation(e){
        this.url = globalThis.location.href.split('?')[0];
        globalThis.history.replaceState({}, null, this.url);
    }

    muteConversation(e){
        e.preventDefault()
        let value = $(e.target).attr('data-value')
        let id = $(e.target).attr('data-id')
        fetch('/rooms/'+ id + '/mute?mute_duration=' + value, {
            method: 'PUT',
            headers: {
                Accept: "text/vnd.turbo-stream.html",
                "X-CSRF-Token": csrfToken,
                'Content-Type': 'application/json'
            }
        }).then(r => r.text())
            .then(html => {
                let truck_modal = document.getElementById('mute_dialog_content').closest('#addFolder');
                const modalController = this.application.getControllerForElementAndIdentifier(truck_modal, "modal");
                modalController.closeModal();
                Turbo.renderStreamMessage(html)
            })
    }

    removeMessage() {
        this?.element?.closest("turbo-frame")?.remove();
    }
}
